import type { UrlLocation } from '@seek/chalice-types';

import type { Country } from 'src/types/globals';

export const LOCATION_CHANGED = 'LOCATION_CHANGED';
export const CAMPAIGN_LINK_CLICKED = 'CAMPAIGN_LINK_CLICKED';
export const SET_REQUEST_ID = 'SET_REQUEST_ID';
export const COUNTRY_CHANGED = 'COUNTRY_CHANGED';
export const LOCATION_HASH_CHANGED = 'LOCATION_HASH_CHANGED';
export const ADD_TO_QUERY = 'ADD_TO_QUERY';
export const REMOVE_FROM_QUERY = 'REMOVE_FROM_QUERY';
export const CLEAR_PAGE_QUERY = 'CLEAR_PAGE_QUERY';

export interface LocationState {
  url: string | null;
  pathname: string;
  prevPathname: string | null;
  query: any;
  pageNumber?: number;
  isHomepage: boolean;
  hostname?: string;
  href?: string;
  hash?: string;
  port?: string;
  protocol?: string;
  requestId?: string;
}

type CountryChangedAction = {
  type: typeof COUNTRY_CHANGED;
  payload: {
    country: Country;
  };
};

type LocationChangedAction = {
  type: typeof LOCATION_CHANGED;
  payload: {
    url: string;
    location: UrlLocation;
  };
};

type LocationHashChangedAction = {
  type: typeof LOCATION_HASH_CHANGED;
  payload: {
    hash: string;
  };
};

type AddToQueryAction = {
  type: typeof ADD_TO_QUERY;
  payload: {
    query: any;
  };
};

type RemoveFromQueryAction = {
  type: typeof REMOVE_FROM_QUERY;
  payload: {
    keys: [string];
  };
};

export type SetRequestIdAction = {
  type: typeof SET_REQUEST_ID;
  payload: {
    requestId?: string;
  };
};

export type ClearPageQueryAction = {
  type: typeof CLEAR_PAGE_QUERY;
};

export type LocationAction =
  | LocationChangedAction
  | LocationHashChangedAction
  | AddToQueryAction
  | RemoveFromQueryAction
  | CountryChangedAction
  | SetRequestIdAction
  | ClearPageQueryAction
  | {
      type: typeof CAMPAIGN_LINK_CLICKED;
      payload: {
        linkName: string;
        trackingCode: string;
      };
    };
